
const GraphQLMutation = require('app/graphql/Mutation');
const Modal = require('app/ui/Modal');

class SendModal {

    defaultOptions() {
        return {
            'orderId': null,
            'title': '',
            'name': '',
            'email': '',
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.onSubmit = this.onSubmit.bind(this);

        this.initialize();
    }

    initialize() {
        var self = this;

        this.modal = new Modal({
            'title': this.settings.title,
            'modalSize': 'xl',
            'showFooter': false,
            'content': this.buildForm()
        });

        this.modal.show();
    }

    buildForm(){
        this.$form = $('<form/>')
        .addClass('order-send-form')
        .append(
        )

        this.$selectType = $('<select/>')
        .attr('name','type')
        .addClass('form-control')
        .attr('required','required')
        .append(
            $('<option/>')
            .attr('value','supplier')
            .append(window.translate('app.order.send.type.supplier'))
        )
        .append(
            $('<option/>')
            .attr('value','restaurant')
            .append(window.translate('app.order.send.type.restaurant'))
        )
        .append(
            $('<option/>')
            .attr('value','commercial')
            .append(window.translate('app.order.send.type.commercial'))
        );

        this.$form
        .append(
            $('<div/>')
            .addClass('form-group')
            .append(
                $('<label/>')
                .append(window.translate('app.order.send.type.label'))
            )
            .append(this.$selectType)
        );

        this.$inputName = $('<input/>')
        .attr('type','text')
        .attr('name','name')
        .attr('required','required')
        .addClass('form-control')
        .val(this.settings.name);

        this.$form
        .append(
            $('<div/>')
            .addClass('form-group')
            .append(
                $('<label/>')
                .append(window.translate('app.order.send.name.label'))
            )
            .append(this.$inputName)
        );

        this.$inputEmail = $('<input/>')
        .attr('type','text')
        .attr('name','email')
        .attr('required','required')
        .addClass('form-control')
        .val(this.settings.email);
        this.$form
        .append(
            $('<div/>')
            .addClass('form-group')
            .append(
                $('<label/>')
                .append(window.translate('email'))
            )
            .append(this.$inputEmail)
        );

        this.$btnSubmit = $('<button/>')
        .attr('type','submit')
        .addClass('btn btn-success')
        .append(
            $('<i/>')
            .addClass('fas fa-envelope me-1')
        )
        .append(window.translate('app.order.send.submit.label'));

        this.$form
        .append(
            $('<div/>')
            .addClass('d-flex justify-content-center mt-4')
            .append(this.$btnSubmit)
        )

        this.$form.on('submit',this.onSubmit);

        return this.$form;
    }

    onSubmit(event){
        var self = this;
        event.preventDefault();
        event.stopPropagation();

        let fields = [
            'success',
            'message',
            'errors { key, value }',
        ];
        let variables = {
            'order': {
                'value': this.settings.orderId,
                'type': 'Int!'
            },
            'type': {
                'value': this.$selectType.val(),
                'type': 'String!'
            },
            'name': {
                'value': this.$inputName.val(),
                'type': 'String!'
            },
            'email': {
                'value': this.$inputEmail.val(),
                'type': 'String!'
            }
        };

        let mutation = new GraphQLMutation({
            //Mutation parameters
            'mutationType': "SendRestaurantOrder",
            'fields': fields,
            'variables': variables,

            //callbacks
            'before': function(){
            },
            'success': function(data){
                if(data.success){
                    window.notify(data.message,'success');
                    self.dispose();
                }else{
                    window.notify(data.message,'error');
                }
            },
            'error': function(message, xhr){
                window.notify(message,'error');
            },
            'after': function(){
            }
        });
        mutation.execute();

    }

    dispose(){
        this.modal.hide();
    }

}

module.exports = SendModal;